import { combineReducers } from "redux";
import createComplaint from './actions/createComplaint';
import getComplaintById from './actions/getComplaintById';
import getComplaintsGeojson from './actions/getComplaintsGeojson';
import getComplaintsPaged from './actions/getComplaintsPaged';
import getComplaintTypes from './actions/getComplaintTypes';
import sentComment from './actions/sentComment';

export const complaints = combineReducers({
    getComplaintsPaged,
    getComplaintById,
    getComplaintTypes,
    getComplaintsGeojson,
    sentComment,
    createComplaint,
});
